/*
 * "Complete the look" on the product page (snippets/product-complementary
 * .liquid, Figma node 7568:5364).
 *
 * The card's "Add to cart" button never posts anything itself: it opens the
 * SAME drawer body the bundle flow uses (sections/bundle-product-drawer
 * .liquid, fetched through the Section Rendering API) so colour and size are
 * picked there. What differs from the bundle flow, and why this file exists
 * rather than a flag inside bundle-builder.js:
 *
 *   - the cart line is an ordinary one — no `_bundle` line properties, no
 *     step bookkeeping, no BundleState;
 *   - there is no discount progress bar. The drawer renders it `hidden` and
 *     only bundle-builder.js ever fills it, so leaving it alone is all it
 *     takes (nothing here calls renderDrawerProgress);
 *   - a successful add bumps the header's cart counter instead of showing
 *     the bundle toast, which draws one cell per bundle step.
 *
 * Option availability inside the drawer (size/length radios constraining
 * each other) is NOT reimplemented here — assets/bundle-drawer-options.js
 * owns it for both pages and binds its own document-level `change` listener.
 */
(function () {
  if (window.__completeLookInit) return;
  window.__completeLookInit = true;

  var DEFAULT_ERROR = 'One of the items just sold out. Please pick another one.';

  function routes() {
    return (window.Shopify && window.Shopify.routes) || { root: '/' };
  }

  /*
   * The drawer is rendered by snippets/product-complementary.liquid, which
   * runs deep inside the product page's right column — under
   * `.product__info-container` (position: sticky, z-index: 2). That is a
   * stacking context AND a containing block for fixed positioning, so left
   * where it is the drawer's own `position: fixed; z-index: 1000` is
   * resolved against that column: the panel starts below the header instead
   * of at the top of the viewport, the overlay stops at the column's edges,
   * and the header (z-index 100 at the root) paints over both. Moving the
   * element to <body> once, before it is ever opened, is what makes those
   * values mean what they say.
   */
  function drawerEl() {
    var drawer = document.querySelector('[data-complete-look-drawer]');
    if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
    return drawer;
  }

  /* `defer` means the DOM is parsed by now — hoist immediately rather than
     on the first click, so the first open is not the one that moves it. */
  drawerEl();

  function startLoading(el) {
    if (!el) return;
    el.setAttribute('data-bundle-loading', '');
    el.setAttribute('aria-busy', 'true');
  }

  function stopLoading(el) {
    if (!el) return;
    el.removeAttribute('data-bundle-loading');
    el.removeAttribute('aria-busy');
  }

  /*
   * Same shape as bundle-builder.js's showDrawerError: the note is created
   * once and reused, so a second failure replaces the text instead of
   * stacking a second paragraph. Styling comes from bundle-builder.css's
   * .bundle-drawer-product__error, already on the page.
   */
  function showError(product, error) {
    var footer = product.querySelector('.bundle-drawer-product__footer');
    if (!footer) return;

    var note = product.querySelector('[data-bundle-error]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'bundle-drawer-product__error';
      note.setAttribute('data-bundle-error', '');
      note.setAttribute('role', 'alert');
      footer.prepend(note);
    }
    note.textContent = (error && (error.description || error.message)) || DEFAULT_ERROR;
  }

  function clearError(product) {
    var note = product.querySelector('[data-bundle-error]');
    if (note) note.remove();
  }

  function drawerUrl(handle, variantId) {
    var url = routes().root + 'products/' + handle + '?section_id=bundle-product-drawer';
    if (variantId) url += '&variant=' + variantId;
    return url;
  }

  /*
   * `step` is deliberately omitted from setBody(): the drawer body's
   * data-step exists for bundle-builder.js's bookkeeping and means nothing
   * here. Availability is recomputed right away because the section renders
   * each radio against the product's own first available variant, which is
   * not necessarily the combination the freshly-rendered fieldsets show as
   * checked.
   */
  function fillDrawer(html) {
    var drawer = drawerEl();
    if (!drawer) return null;

    drawer.setBody(html);

    var product = drawer.querySelector('[data-bundle-product]');
    if (product && window.BundleDrawerOptions) window.BundleDrawerOptions.recompute(product);
    return product;
  }

  function openDrawer(handle, opener) {
    return fetch(drawerUrl(handle))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var drawer = drawerEl();
        if (!drawer) return;
        fillDrawer(html);
        drawer.open(opener);
      });
  }

  function addToCart(variantId) {
    return fetch(routes().cart_add_url ? routes().cart_add_url + '.js' : routes().root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  /*
   * The theme has no cart drawer (settings.cart_type is "notification" and
   * the popup itself is switched off), so the only visible confirmation is
   * the header counter's bump — the same call bundle-builder.js makes.
   */
  function refreshCartCount() {
    return fetch(routes().root + 'cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var notification = document.querySelector('cart-notification');
        if (notification && typeof notification.updateCartCount === 'function') {
          notification.updateCartCount(cart.item_count);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-complete-look-add]');
    if (add) {
      if (add.hasAttribute('data-bundle-loading')) return;

      var card = add.closest('[data-complete-look-card]');
      var handle = add.getAttribute('data-product-handle') ||
        (card && card.getAttribute('data-product-handle'));
      if (!handle) return;

      startLoading(add);
      openDrawer(handle, add)
        .catch(function () {})
        .finally(function () { stopLoading(add); });
      return;
    }

    var drawer = drawerEl();
    if (!drawer) return;

    /* Colour swatch inside the drawer: colour is a separate product in this
       store, so picking one swaps the whole drawer body for that sibling's
       render. The page URL must not change — the shopper is mid-way through
       a different product's page. */
    var swatch = event.target.closest('[data-bundle-swatch]');
    if (swatch && drawer.contains(swatch)) {
      event.preventDefault();
      fetch(drawerUrl(swatch.getAttribute('data-bundle-swatch')))
        .then(function (response) { return response.text(); })
        .then(fillDrawer)
        .catch(function () {});
      return;
    }

    /* Confirm. The button's data-variant-id is kept current by
       bundle-drawer-options.js on every radio change, so this always adds
       the combination actually shown as selected. */
    var confirm = event.target.closest('[data-bundle-confirm]');
    if (!confirm || !drawer.contains(confirm)) return;

    var product = confirm.closest('[data-bundle-product]');
    if (!product) return;

    var variantId = Number(confirm.getAttribute('data-variant-id'));
    if (!variantId) return;

    clearError(product);
    startLoading(confirm);
    confirm.disabled = true;

    addToCart(variantId)
      .then(refreshCartCount)
      .then(function () { drawer.close(); })
      .catch(function (error) { showError(product, error); })
      /* Re-enabled on the failure path so the shopper can pick another size
         and try again — unless the variant now on the button is itself sold
         out, which bundle-drawer-options.js records as an attribute. On the
         success path the drawer is closing and its body is re-fetched next
         time it opens, so what this leaves behind is never seen. */
      .finally(function () {
        stopLoading(confirm);
        confirm.disabled = confirm.hasAttribute('data-bundle-unavailable');
      });
  });
})();
